import { Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { FC } from "react";

Chart.register(...registerables); // Register necessary Chart.js components

interface PropsType
{
  data:{ labels: string[]; datasets: { label: string; data: number[]; }[]; },
  xtitle:string,
  ytitle:string,
  title:string,
  legends?:boolean,
}

const LineChart:FC<PropsType> = ({data,xtitle,ytitle,title,legends}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
        line: {
          borderColor: (context:{datasetIndex:number}) => {
            const colors = ["#3C50E0", "#FF5733"];
            return colors[context.datasetIndex];
          },
          backgroundColor: (context:{datasetIndex:number}) => {
            const colors = ["#3C50E0", "#FF5733"];
            return colors[context.datasetIndex];
          },
          tension: 0,
          fill: false,
          borderWidth: 1,
        },
        point: {
          radius: 0,
          backgroundColor: "#3C50E0",
        },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xtitle,
          font: {
            size: 16,
          },
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10,
          stepSize: 2,
        },
      },
      y: {
        title: {
          display: true,
          text: ytitle,
          font: {
            size: 16,
          },
        },
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        display: legends? true : false,
        position: "top" as const,
      },
      title: {
        display: title? true:false,
        text: title || "Line Chart",
        font: {
          size: 18,
        },
        padding: {
          top: 10,
          bottom: 20,
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "400px", backgroundColor: "#ffffff", padding: "20px", borderRadius: "8px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
